import {
  IconName,
  IconSize,
  Link,
  PlainIcon,
  ProColors,
  ScreenSize,
  useIsScreenSize,
} from '@treatwell/treatwell-aura';
import { css } from '@emotion/react';
import { Trans, useTranslation } from 'react-i18next';
import { FooterLeftComponentProps } from '../screens/templates';
import { Form, Prompt, Title } from './templates';

type RowProps = {
  icon: IconName;
  iconColor: string;
  iconBackgroundColor: string;
  text: string;
};

const Row = (props: RowProps) => (
  <li
    css={css({
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
    })}
  >
    <PlainIcon
      size={IconSize.SMALL}
      name={props.icon}
      color={props.iconColor}
      backgroundColor={props.iconBackgroundColor}
      borderRadius={999}
      css={css({ padding: 8 })}
    />
    <div
      className="aura--copy-normal"
      css={css({ color: ProColors.navy[800], fontWeight: 700 })}
    >
      {props.text}
    </div>
  </li>
);

export function FooterLogin({ t, isSMAndUnder }: FooterLeftComponentProps) {
  return (
    <div
      css={css({
        display: 'flex',
        flexDirection: isSMAndUnder ? 'column' : 'row',
        gap: '4px',
      })}
    >
      <span
        className="aura--copy-normal"
        css={css({
          color: ProColors.navy[800],
          fontWeight: 700,
        })}
      >
        {t('alreadyPartner')}
      </span>
      <Link to={`${window.location.origin}/calendar`}>{t('login')}</Link>
    </div>
  );
}

export function StepContext() {
  const { t } = useTranslation('stepContext');
  const isSMAndUnder = useIsScreenSize(ScreenSize.SMAndUnder);

  return (
    <Form css={css({ gap: '32px' })}>
      <Title
        text={
          <Trans
            t={t}
            i18nKey="title"
            transKeepBasicHtmlNodesFor={['br']}
            components={[<span css={css({ color: ProColors.teal[600] })} />]}
          />
        }
      />
      <Prompt
        text={
          <Trans t={t} i18nKey="prompt" transKeepBasicHtmlNodesFor={['br']} />
        }
      />
      <ul
        css={css({
          display: 'flex',
          flexDirection: 'column',
          gap: isSMAndUnder ? '16px' : '24px',
          listStyle: 'none',
          padding: 0,
          margin: 0,
        })}
      >
        <Row
          icon={IconName.TW_PRO_ADD_USER}
          iconColor={ProColors.teal[600]}
          iconBackgroundColor={ProColors.teal[100]}
          text={t('attractNewClients')}
        />
        <Row
          icon={IconName.TW_PRO_CALENDAR}
          iconColor={ProColors.purple[600]}
          iconBackgroundColor={ProColors.blue[100]}
          text={t('manageAppointments')}
        />
        <Row
          icon={IconName.TW_PRO_HAPPY}
          iconColor={ProColors.yellow[600]}
          iconBackgroundColor={ProColors.yellow[100]}
          text={t('buildRelationships')}
        />
        <Row
          icon={IconName.TW_PRO_NEW_VENUE}
          iconColor={ProColors.coral[600]}
          iconBackgroundColor={ProColors.coral[100]}
          text={t('growBusiness')}
        />
      </ul>
      <Prompt text={t('prompt2')} />
    </Form>
  );
}
